import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { usePost } from "seed/api";
import View from "components/util/schema_form/fields/smart_text/SmartText.view";
import l from "components/util/l";


function SmartText({
  name,
  objective = "",
  examples,
  depth = 5,
  flowId,
  nodeId,
  setFieldValue,
}) {

  const [schema, setSchema] = useState([]);
  const [schemaValues, setSchemaValues] = useState({});

  const [callGeneratedSchema, reqCallGeneratedSchema] = usePost("/apps/forms/generate_schema_form_from_prompt", {
    onCompleted: (data) => {
      setSchema(data?.schema ?? schema);
      setFieldValue(name, data?.schema ?? schema);
    },
    onError: (error) => {
      swal("Error", l("Error al generar las preguntas, intente de nuevo mas tarde%SC145"), "error");
    }
  });


  useEffect(() => {
    callGeneratedSchema({
      objective: objective,
      examples: examples,
      depth: depth
    });
  }, []);

  const onClickSubmit = (values) => {
    setSchemaValues(values);
    callGeneratedSchema({
      objective: objective,
      depth: depth,
      examples: examples,
      schema: schema,
      values: schemaValues,
    });
  }


  const isLoading = reqCallGeneratedSchema.loading; 


  return (
    <View
      schema={schema}
      schemaValues={schemaValues}
      flowId={flowId}
      nodeId={nodeId}
      isLoading={isLoading}
      onClickSubmit={onClickSubmit}
    />
  )
}



export default SmartText;